import {ProductSummary} from '~/features/shared';
import {ProductsSliderDesktop} from './ProductsSliderDesktop';
import {ProductsSliderMobile} from './ProductsSliderMobile';

export interface ProductsSliderProps {
  items: ProductSummary[];
}

export function ProductsSlider({...props}: ProductsSliderProps) {
  return (
    <>
      <ProductsSliderDesktop {...props} />
      <ProductsSliderMobile {...props} />
    </>
  );
}
